var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"target":"_blank"},on:{"click":_vm.trackEvent}},[_c('Icon',{attrs:{"icon":"pdf"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }